export default __webpack_public_path__ + "static/media/imgcard.0cc1c653.png";